export default __webpack_public_path__ + "static/media/boulder.a8c6811e.jpg";